"use strict";
/**
 * Returns the charge of a molecule
 * @param {import('openchemlib').Molecule} molecule an instance of OCL.Molecule
 * @returns {number}
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCharge = void 0;
function getCharge(molecule) {
    let charge = 0;
    for (let i = 0; i < molecule.getAllAtoms(); i++) {
        charge += molecule.getAtomCharge(i);
    }
    return charge;
}
exports.getCharge = getCharge;
//# sourceMappingURL=getCharge.js.map